// Общие стили «Остатков» - те же, что в «Электронном журнале» (панель, таблицы, чипы)

export const BORDER = '#e2e8f0';

export const chipSx = { bgcolor: 'rgba(37,99,235,0.07)', color: '#1e40af', fontWeight: 600, borderRadius: 1.5 };
export const buttonSx = { height: 40, textTransform: 'none', fontWeight: 600, borderRadius: 1.5 } as const;

export const panelSx = { borderColor: BORDER, borderRadius: 2, overflow: 'hidden', bgcolor: '#fff' };
export const tableContainerSx = { maxHeight: 'calc(100vh - 380px)', minHeight: 260 };
export const headCellSx = { fontWeight: 700, fontSize: 12, color: '#475569', bgcolor: '#f8fafc', borderBottom: `1px solid ${BORDER}`, whiteSpace: 'nowrap' };
export const rowSx = { '& td': { borderBottom: '1px solid #f1f5f9', py: 0.75, fontSize: 13, verticalAlign: 'middle' } };

export const smallChipSx = { height: 22, fontSize: 11.5, fontWeight: 600, borderRadius: 1.25 };

export const tabsSx = {
  minHeight: 40,
  '& .MuiTab-root': { minHeight: 40, py: 0.5, px: 2, textTransform: 'none', fontSize: '0.88rem', fontWeight: 600 }
};

/** Пустое значение из 1С или профиля аптеки */
export const EMPTY_TEXT = 'не указано';
export const emptySx = { fontSize: 12.5, color: '#94a3b8' };

/** Состояние аптеки сейчас: открыта / закрыта / режим работы не указан */
export const OPEN_COLORS = {
  open: { color: '#15803d', bg: 'rgba(22,163,74,0.09)', marker: '#16a34a' },
  closed: { color: '#64748b', bg: 'rgba(100,116,139,0.1)', marker: '#94a3b8' },
  unknown: { color: '#2563eb', bg: 'rgba(37,99,235,0.07)', marker: '#2563eb' }
};

export const openKey = (open: boolean | null): keyof typeof OPEN_COLORS => (open === true ? 'open' : open === false ? 'closed' : 'unknown');
